<div class="commerical-page">
  <nav class="navbar navbar-expand-md navbar-dark bg-dark" id="navbarhead">
    <div class="sectpad container-fluid">
      <a
        class="navbar-brand logomain logomainpge"
        href="javascript:void(0)"
        routerLink="/"
      >
        <img
          src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569491666/Static%20images/Logo/honestgorilla-logo-black_hx8ekn.svg"
          alt="Honest Gorilla combo logo in blank"
          title="Black Honest Gorilla combo logo with Eva face"
          height="60"
          class="logo logohead drag-drop"
          alt="Honest Gorilla" />
        <img
          src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569491829/Static%20images/Logo/honestgorilla-title-black_ux1q8j.svg"
          alt="Honest Gorilla logo in black"
          title="Black Honest Gorilla logo"
          class="logo1 mt-2"
      /></a>
      <button
        (click)="addClass($event)"
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarsExampleDefault"
        aria-controls="navbarsExampleDefault"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <img
          src="assets/images/list-charcoal.png"
          width="18"
          id="menuIcon"
          class="listicn"
        />
      </button>
      <div class="collapse navbar-collapse" id="navbarsExampleDefault">
        <ul class="navbar-nav ml-auto webnav">
          <li class="nav-item">
            <a class="nav-link" href="javascript:void(0)" routerLink="/"
              >RESIDENTIAL</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              href="javascript:void(0)"
              (click)="faqus()"
              routerLink="/faq"
              >FAQ</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" href="javascript:void(0)" routerLink="/blog"
              >BLOG</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" href="javascript:void(0)" routerLink="/giveback"
              >GIVEBACK</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              href="javascript:void(0)"
              (click)="fcontactus()"
              routerLink="/faq/contact-us"
              >CONTACT US</a
            >
          </li>
          <li class="nav-item" *ngIf="!showLogin">
            <a
              class="nav-link"
              href="javascript:void(0)"
              (click)="gotoProfile()"
              >PROFILE</a
            >
          </li>
        </ul>
        <div class="mobilenav" *ngIf="!showLogin">
          <div class="col-12 row m-0 p-0">
            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold" routerLink="/">Residential</h5>
            </div>
            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold" routerLink="/faq/contact-us">
                Contact us
              </h5>
            </div>
          </div>
          <div class="col-12 row m-0 p-0">
            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold" routerLink="/faq">FAQ</h5>
            </div>
            <div class="col-6 col-md mb-2 mt-2" *ngIf="!showLogin">
              <h5 class="font16 semi-bold" (click)="gotoProfile()">Profile</h5>
            </div>
          </div>
          <div class="col-12 row m-0 p-0">
            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold" routerLink="/blog">Blog</h5>
            </div>
            <div class="col-6 col-md mb-2 mt-2" *ngIf="!showLogin">
              <h5 class="font16 semi-bold" (click)="logoutFun()" routerLink="/">
                Logout
              </h5>
            </div>
            <div class="col-6 col-md mb-2 pt-1 mt-2">
              <h5 class="font16 semi-bold" routerLink="/giveback">Giveback</h5>
            </div>
            <div class="col-6 col-md mb-2 mt-2 p-0">
              <a
                href="javascript:void(0)"
                class="btnsec font14"
                routerLink="/commercial/questionnaire"
                >SHOP NOW</a
              >
            </div>
          </div>
          <div class="col-12 row m-0 p-0"></div>
        </div>
        <div class="mobilenav" *ngIf="showLogin">
          <div class="col-12 row m-0 p-0">
            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold" routerLink="/">Residential</h5>
            </div>
            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold" routerLink="/giveback">Giveback</h5>
            </div>
          </div>
          <div class="col-12 row m-0 p-0">
            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold" routerLink="/faq">FAQ</h5>
            </div>
            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold" routerLink="/faq/contact-us">
                Contact us
              </h5>
            </div>
          </div>
          <div class="col-12 row m-0 p-0">
            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold" routerLink="/blog">Blog</h5>
            </div>
            <div class="col-6 col-md mb-2 mt-2" *ngIf="!showLogin">
              <h5 class="font16 semi-bold" (click)="gotoProfile()">Profile</h5>
            </div>
          </div>
          <div class="col-12 row m-0 p-0" *ngIf="!showLogin">
            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold"></h5>
            </div>
            <div class="col-6 col-md mb-2 mt-2" *ngIf="!showLogin">
              <h5 class="font16 semi-bold" (click)="logoutFun()" routerLink="/">
                Logout
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div class="webview">
        <a
          class="btn btn-wp-primary mr-2 ml-2 getstart"
          *ngIf="!showLogin"
          href="javascript:void(0)"
          (click)="logoutFun()"
          >LOGOUT</a
        >
      </div>

      <a
        class="btn btn-wpu-primary getstart"
        routerLink="/commercial/questionnaire"
        >SHOP NOW</a
      >
      <div class="mobileview">
        <a
          class="btn btn-wpu-primary login mobileview"
          style="position: fixed"
          routerLink="/commercial/questionnaire"
          href="javascript:void(0)"
          >SHOP NOW</a
        >
      </div>
    </div>
  </nav>
</div>
